// Keep the attendee workflow hidden until it is ready for release.
export const TRADE_SHOW_ATTENDEES_ENABLED = process.env.REACT_APP_TRADE_SHOW_ATTENDEES_ENABLED === "true";
